import React from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';
import FastButton from 'components/FastButton';
import './NestCard.scss';

function NestCard({nestNumber, checked, onCheck, scanned, onScan, onReScan, isError}) {
  const checkboxId = `checkbox-nest-${nestNumber}`;

  const getCardClass = () => {
    if (scanned) {
      return isError ? 'nest-card scanned-error' : 'nest-card scanned-success';
    }
    return 'nest-card unscanned';
  };

  const renderIcon = () => {
    if (!scanned) return <FmlxIcon name="StackDeck" />;

    return (
      <div className="nest-plate-icon">
        <FmlxIcon name="FastPlateVertical" />
        <FmlxIcon name={isError ? 'HelpCircle' : 'CheckboxDefault'} />
      </div>
    );
  };

  const renderStatus = () => {
    if (!scanned) {
      return (
        <div className="nest-checkbox">
          <input type="checkbox" id={checkboxId} checked={checked} onChange={onCheck} />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor={checkboxId}>Place the labware in the nest</label>
        </div>
      );
    }

    if (isError) {
      return (
        <div className="no-plate">
          <div className="error-text">No plate</div>
          <span>Put the labware, then do the rescan.</span>
        </div>
      );
    }

    return <div className="plate-scanned">Plate scanned</div>;
  };

  return (
    <div className={getCardClass()}>
      <h3 className="nest-title">Nest {nestNumber}</h3>
      <div className="nest-content">
        <div className="nest-icon">{renderIcon()}</div>
        {renderStatus()}
      </div>
      <div className="nest-scan-btn">
        <FastButton
          fitContainer
          disabled={!checked}
          onClick={scanned ? onReScan : onScan}
          label={scanned ? 'RESCAN' : 'SCAN PLATE'}
        />
      </div>
    </div>
  );
}

NestCard.propTypes = {
  nestNumber: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
  scanned: PropTypes.bool.isRequired,
  onScan: PropTypes.func.isRequired,
  onReScan: PropTypes.func.isRequired,
  isError: PropTypes.bool.isRequired,
};

export default NestCard;
